export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14114.19e37668.jpg";